module.exports = __webpack_public_path__ + "img/73_19.3e97dc44.png";